import $api from "../http";
import { AxiosResponse } from "axios";
import { authResponse } from "../models/response/authResponse";
import { IUser } from "../models/IUser";

export default class AuthService {
  static async login(
    email: string,
    password: string
  ): Promise<AxiosResponse<authResponse>> {
    return $api.post("/login", { email, password });
  }

  static async registration(
    email: string,
    password: string,
    firstName: string,
    lastName: string,
    middleName: string,
    workPlace: string,
    diplomaNumber: string,
    phone: number
  ): Promise<AxiosResponse<authResponse>> {
    return $api.post("/registration", {
      email,
      password,
      firstName,
      lastName,
      middleName,
      workPlace,
      diplomaNumber,
      phone,
    });
  }

  static async updateUser(
    email: string,
    firstName: string,
    lastName: string,
    middleName: string,
    workPlace: string,
    diplomaNumber: string,
    phone: number
  ): Promise<AxiosResponse<authResponse>> {
    const user: {
      email: string;
      firstName?: string;
      lastName?: string;
      middleName?: string;
      workPlace?: string;
      diplomaNumber?: string;
      phone?: number;
    } = { email: email };
    if (firstName !== "") {
      user.firstName = firstName;
    }
    if (lastName !== "") {
      user.lastName = lastName;
    }
    if (middleName !== "") {
      user.middleName = middleName;
    }
    if (workPlace !== "") {
      user.workPlace = workPlace;
    }
    if (diplomaNumber !== "") {
      user.diplomaNumber = diplomaNumber;
    }
    if (phone) {
      user.phone = phone;
    }
    return $api.post("/update-user", { ...user });
  }

  static async updatePassword(
    id: string,
    password: string,
    passwordNew: string
  ): Promise<AxiosResponse<authResponse>> {
    return $api.post("/update-password", { id, password, passwordNew });
  }

  static async activateUser(
    email: string,
    isActivated: boolean,
    user: IUser
  ): Promise<AxiosResponse<authResponse>> {
    return $api.post("/activate-user", { email, isActivated, user });
  }

  static async logout(): Promise<AxiosResponse<authResponse>> {
    return $api.post("/logout");
  }

  static async restoreLink(
    email: string
  ): Promise<AxiosResponse<authResponse>> {
    return $api.post("/restore-link", { email });
  }

  static async restorePassword(
    password: string,
    link: string
  ): Promise<AxiosResponse<authResponse>> {
    return $api.post("/restore-password", { password, link });
  }
}
